/**
 * Routes
 */
export const ACTIVITY_STATEMENTS_ROUTE = 'account/activity-statements'

/**
 * Tab keys
 */
export const TRANSACTION_STATEMENTS_TAB_KEY = 'transaction_statement'
export const ACTIVITY_STATEMENTS_TAB_KEY = 'activity_statement'
